
/*Added by KoderWeb*/
class carouselSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('.carousel-slider');

    this.desktopShow = this.slider.dataset.desktop;
    this.mobileShow = this.slider.dataset.mobile;
    this.slideAutoplay = this.slider.dataset.autoplay;
    this.slideAutoplaySpeed = this.slider.dataset.autoplaySpeed;

     
    this.sliderInit();
  }

  sliderInit() {
    var slider = this.slider.getAttribute('id'),
        slider = '#'+slider,
        desktop = this.desktopShow * 1,
        mobile = this.mobileShow * 1,
        autoPlay = this.slideAutoplay,
        autoPlaySpped = this.slideAutoplaySpeed * 1000;

    $(slider).slick({

      // slidesToShow: desktop,
      // slidesToScroll: 1,
      // infinite: true,
      // arrows: true,
      // prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true"><svg class="icon left-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"></polygon></svg></button>',
      // nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg class="icon right-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"></polygon></svg></button>',
      
        dots: false,
        arrows: true,
        infinite: true,
        fade: false,
        speed: 800,
        slidesToShow: desktop,
        slidesToScroll: 1,
        autoplay: autoPlay,
        pauseOnHover: false,
        autoplaySpeed: autoPlaySpped,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true"><svg class="icon left-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"></polygon></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg class="icon right-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"></polygon></svg></button>',
      

        responsive: [{

          breakpoint: 1024,
          settings: {
            slidesToShow: desktop - 1,
          }

        }, {

          breakpoint: 750,
          settings: {
            slidesToShow: mobile,
          }

        },
        {

          breakpoint: 480,
          settings: {
            slidesToShow: mobile === 2 ? mobile - 1 : mobile,
          }

        }, {

          breakpoint: 300,
          settings: "unslick" // destroys slick
        }]
    });

  
  }
}

customElements.define('carousel-slider', carouselSlider);


var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.settings.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
// inspired by https://discount-on-cart-pro.myshopify.com/cart
document.addEventListener("DOMContentLoaded", function(event) { 
  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
  let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
  let discountCodeInput = document.querySelector("#discount-code-input");
  let totalCartSelectorWrap = document.querySelector(".subtotal_cart"); // Total Cart Selector to update the total amount. 
  let totalCartSelector = totalCartSelectorWrap ? totalCartSelectorWrap.querySelector("[data-subtotal]") : null; // Total Cart Selector to update the total amount. 
  let authorization_token;
 
  
  let checkoutContainer = document.createElement('div');
  document.body.appendChild(checkoutContainer);
  //if (localStorage.discountCode) applyDiscount( JSON.parse(localStorage.discountCode).code);
  if (localStorage.discountCode) {
    //console.log(localStorage.discountCode, 'first apply')
    applyDiscount(JSON.parse(localStorage.discountCode).code);
    //console.log(localStorage.discountCode, 'localstore');
  }
  if(applyBtn)
  applyBtn.addEventListener("click", function(e){
    e.preventDefault()
    applyDiscount(discountCodeInput.value);
  });
  if(clearBtn)
  clearBtn.addEventListener("click", function(e){
    e.preventDefault()
    clearDiscount();
  });
  document.addEventListener('cart:quantity.cart-page', function() {
    // update quanity
    setTimeout(function(){
      if (localStorage.discountCode) {
        applyDiscount(JSON.parse(localStorage.discountCode).code);
      }
    }, 300);
  });
  // document.addEventListener('cart:updated', function(evt) {
  //   //console.log('cart:updated', evt.detail.item_count)
  //   if (evt.detail.item_count === 0) {
  //     clearDiscount();
  //   }
  // });

  //Clear discount code
  fetch("/cart.js", {"method": "GET"})
  .then((response) => response.json())
  .then((data) => {
      if (data.item_count === 0 ) {
        clearDiscount();
      }
  })
  .catch((e) => {
    console.error(e);
  }); 

  function clearDiscount() {
    

    clearLocalStorage();
    
    fetch("/discount/CLEAR");

    setTimeout(function(){
      fetch("/cart?section_id=main-cart", {"method": "GET"})
      .then((response) => response.text())
      .then((responseText) => {
        
        discountCodeValue.innerHTML = "";
        discountCodeError.innerHTML = "";
        discountCodeInput.value = "";

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // const sourceQty = html.querySelector('[data-products]');
        // document.querySelector('[data-products]').innerHTML = sourceQty.innerHTML;

        const sourceQty = html.querySelectorAll('.cart__item-price-col');
        sourceQty.forEach((item, i) => {
            document.querySelectorAll('.cart__item-price-col')[i].innerHTML = item.innerHTML;
        });
        //console.log(sourceQty)
        
        document.querySelector('[data-subtotal]').innerHTML = html.querySelector('[data-subtotal]').innerHTML;
        
        let subTotal = document.querySelector('.subtotal');
        let discount_text = document.querySelector('.discount_text');

        //console.log('clear subtotal', subTotal)
        if(subTotal) subTotal.remove();
        if(discount_text) discount_text.remove();
        if(totalCartSelector) totalCartSelector.classList.remove('totals__total-value-discount');
             
      })
      .catch((e) => {
        console.error(e);
      }); 
    }, 500);

    

  }
  function clearLocalStorage() {
    if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
    //if(totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
     if(totalCartSelector) {
      if (localStorage.discountCode) {
      totalCartSelector.innerHTML = Shopify.formatMoney(JSON.parse(localStorage.discountCode).totalCart, Shopify.money_format);
      }
     }
    //console.log(JSON.parse(localStorage.discountCode).code, 'clear')
    localStorage.removeItem('discountCode');   
    window.localStorage.removeItem('discount_code'); 
    //console.log(JSON.parse(localStorage.discountCode).code, 'clearDone')
 
  }
  function applyDiscount(code) {
      if (applyBtn) {
          applyBtn.innerHTML = "<div class='loader'></div>";
          applyBtn.style.pointerEvents = "none";
      }
  
   fetch("/cart.js")
    .then(response => {
        console.log("Response received:", response);
        return response.json(); // Convert response to JSON
    })
    .then(cartData => { 
        console.log("Cart Data:", cartData); // Debugging cart data
  
       // return cartData; // Ensure it's passed to the next .then()

       if (!cartData || cartData.items.length === 0) {
            console.error("Cart is empty, cannot apply discount.");
            return;
        }

        let discountApplyUrl = `/discount/${code}`;

        // Apply the discount using fetch (this simulates clicking the discount link)
        return fetch(discountApplyUrl, { method: "GET" });

      
    })
    .then(data => { 
      

       fetch("/cart.js")
      .then(response => { return response.json(); 
      })
      .then(cartData => { return cartData;}) 
         .then(data => { 
           console.log('newData', data)
           if(data.total_discount > 0){
             fetch("/cart?section_id=main-cart", {"method": "GET"})
              .then((response) => response.text())
              .then((responseText) => {
  
                
  
  
              const htmls = new DOMParser().parseFromString(responseText, 'text/html');

                console.log(htmls)
              //const sourceQtys = htmls.querySelector('[data-products]');
              //document.querySelector('[data-products]').innerHTML = sourceQtys.innerHTML;
  
              const sourceQtys = htmls.querySelectorAll('.cart__item-price-col');
             // console.log(sourceQtys)
  
              sourceQtys.forEach((item, i) => {
                  document.querySelectorAll('.cart__item-price-col')[i].innerHTML = item.innerHTML;
              });
              //document.querySelectorAll('.cart__item').innerHTML = sourceQtys.innerHTML;
  
              
  
  
              if(discountCodeWrapper) discountCodeWrapper.style.display = "inline-block";
              if(discountCodeError) discountCodeError.innerHTML = "";
              if(discountCodeValue) discountCodeValue.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg><span>'+code + " (" + Shopify.formatMoney(data.total_discount, Shopify.money_format) + ")</span>";
              let localStorageValue = {
                'code': code,
                'totalCart': data.total_price
              };
              localStorage.setItem("discountCode", JSON.stringify(localStorageValue));

             
              let subTotal = htmls.querySelector('.subtotal');
              let discount_text = htmls.querySelector('.discount_text');
  
              //console.log('clear subtotal', subTotal)
              if(subTotal) subTotal.remove();
              if(discount_text) discount_text.remove();
  
              if(totalCartSelectorWrap){
                totalCartSelectorWrap.insertAdjacentHTML("beforeBegin", '<div class="subtotal totals"><div class="totals__sub__total">Subtotal</div> <p class="totals__total-value">'+ Shopify.formatMoney(data.original_total_price, Shopify.money_format)+'</p></div>');
                totalCartSelectorWrap.insertAdjacentHTML("beforeBegin", '<div class="discount_text totals"><div class="totals__sub__total">'+code+'</div> <p class="totals__total-value totals__total-value-discount"> -'+ Shopify.formatMoney(data.total_discount, Shopify.money_format)+'</p></div>');
              }
              
              //if(totalCartSelector) totalCartSelector.innerHTML = data.checkout.total_price + ' '+data.checkout.currency;
              if(totalCartSelector) totalCartSelector.innerHTML = Shopify.formatMoney(data.total_price, Shopify.money_format);
              if(totalCartSelector) totalCartSelector.classList.add('totals__total-value-discount');
  
  
              })
              .catch((e) => {
                console.error(e);
              });
               
           }else{
              if(discountCodeValue) discountCodeValue.innerHTML = "";
              clearLocalStorage();
              if(discountCodeError) discountCodeError.innerHTML = "Please enter valid coupon code."
              
              let subTotal = document.querySelector('.subtotal');
              let discount_text = document.querySelector('.discount_text');
             
              if(subTotal) subTotal.innerHTML = ""
              if(discount_text) discount_text.innerHTML = ""
    
            }
        
         });
      
    })
    .catch(error => {
        console.error("Error fetching cart:", error);
        if (discountCodeError) discountCodeError.innerHTML = "Please enter a valid coupon code.";
    })
    .finally(() => {
        if (applyBtn) {
            applyBtn.innerHTML = "APPLY";
            applyBtn.style.pointerEvents = "all";
        }
    });

    
  }

});